import { useCallback, useEffect, useRef } from 'react';
export const useFitToViewportBottom = (enabled, property = 'maxHeight') => {
    const elementRef = useRef(null);
    const update = useCallback(() => {
        const el = elementRef.current;
        if (!el)
            return;
        const rect = el.getBoundingClientRect();
        el.style[property] = `${Math.max(0, window.innerHeight - rect.top)}px`;
        if (property === 'height') {
            const overflow = document.documentElement.scrollHeight - window.innerHeight;
            if (overflow > 0) {
                el.style.height = `${Math.max(0, window.innerHeight - rect.top - overflow)}px`;
            }
        }
    }, [property]);
    useEffect(() => {
        if (!enabled)
            return undefined;
        let frame = 0;
        const schedule = () => {
            if (frame)
                return;
            frame = window.requestAnimationFrame(() => {
                frame = 0;
                update();
            });
        };
        update();
        window.addEventListener('resize', schedule);
        return () => {
            if (frame)
                window.cancelAnimationFrame(frame);
            window.removeEventListener('resize', schedule);
        };
    }, [enabled, update]);
    return useCallback((node) => {
        elementRef.current = node;
        if (node && enabled)
            update();
    }, [enabled, update]);
};
